import React, { ComponentProps } from "react";
import InputShell, { Props as InputShellProps } from "./InputShell";
import ReactInputMask from "react-input-mask";

type Props = {
  onChange: (newValue: string) => void;
  value: string;
} & Partial<Omit<InputShellProps, "children">> &
  Omit<ComponentProps<typeof ReactInputMask>, "onChange">;

function InputMask({ label, onChange, error, value, isOptional, ...rest }: Props) {
  const inputShell = {
    label,
    error,
    ...(isOptional
      ? { isOptional, optionalLabel: rest.optionalLabel }
      : { required: rest.required })
  };
  return (
    <InputShell {...inputShell}>
      <ReactInputMask
        className="min-h-[2.5rem] w-full rounded-[0.25rem] border border-outline px-3 text-sm leading-4 focus:outline-none disabled:bg-slate-100 disabled:text-slate-500"
        title={label}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        value={value}
        autoComplete="off"
        {...rest}
      />
    </InputShell>
  );
}

export default InputMask;
